<template>
    <div>

        <div style="display: flex;width: 100%;">
            <div  v-if="isShow" style="width: 20%;">
                <FullCalendar  ref="fullCalendar" class="demo-app-calendar" :options="calendarOptionss">
                    <template v-slot:eventContent="arg">
                        <div>
                            <div style="text-align: center;"> {{ arg.event.extendedProps.S }} ~ {{ arg.event.extendedProps.E }}  </div>
                            <div style="text-align: center;" > {{ arg.event.title }} </div>
                        </div>
                    </template>
                    <template v-slot:dayHeaderContent="{ }">
                         <span style="color: rgb(15 177 230);">{{ realname }}</span>
                    </template>
                </FullCalendar>
            </div>
            <div  style="margin: 0px 20px;width: 60%;">
                   <div style=" display: flex;margin-bottom: 20px;">
                        <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;width: 120px;">学员</div>
                        <div style="width: 100%">
                            <el-select style="width: 100%"  v-model="studentIds"   placeholder="请选择学员" filterable @change="handleChange">
                                <el-option   style="margin-left: 10px"  v-for="item in studentList"  :key="item.id"  :label="item.realname"  :value="item.id"   >  </el-option>
                            </el-select>
                        </div>
                    </div>


                    <div style=" display: flex;margin-bottom: 20px;">
                        <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;width: 120px;">日期</div>
                        <div style="width: 100%">
                            <el-date-picker type="date" placeholder="选择日期"  style="width: 100%"  value-format="yyyy-MM-dd"  v-model="date"  clearable @change="handleChangeDate"></el-date-picker>
                        </div>
                    </div>


                    <div style=" display: flex;margin-bottom: 20px;">
                        <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;width: 120px;">开始时间</div>
                        <div style="width: 100%" :class="studentIds ? '' : 'no-click' ">
                            <mz-time-select :timePeriod="'start'" @startTimeSelect="startTimeSelect"  :childPlaceholder="'开始时间'" :valueTime="startTime"></mz-time-select>
                        </div>
                    </div>


                    <div style=" display: flex;margin-bottom: 20px;">
                        <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;width: 120px;">结束时间</div>
                        <div style="width: 100%" :class="studentIds ? '' : 'no-click' ">
                            <mz-time-select :timePeriod="'end'" :childPlaceholder="'结束时间'" @startTimeSelect="startTimeSelect"  :valueTime="endTime"></mz-time-select>
                        </div>
                    </div>

                    <!-- <div style=" display: flex;margin-bottom: 20px;">
                        <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;width: 120px;">班型</div>
                        <div style="width: 100%">
                          <el-select style="width: 100%" v-model="ClassType" placeholder="请选择"  filterable  >
                            <el-option  style="margin-left: 10px" v-for="item in classPersonTypeList1"  :key="item.id"  :label="item.name"  :value="item.id"></el-option>
                          </el-select>
                        </div>
                    </div> -->

                    <div style=" display: flex;margin-bottom: 20px;">
                        <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;width: 120px;">上课人员类型</div>
                        <div style="width: 100%">
                          <el-select style="width: 100%" v-model="classPersonType" placeholder="请选择"  filterable  @focus="handleChanges">
                            <el-option  style="margin-left: 10px" v-for="item in classPersonTypeList"  :key="item.id"  :label="item.name"  :value="item.id"></el-option>
                          </el-select>
                        </div>
                    </div>


                    <div style=" display: flex;margin-bottom: 20px;">
                        <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;width: 120px;">上课方式</div>
                        <div style="width: 100%;text-align: start;padding-top: 12px;">
                            <el-radio-group v-model="educationType">
                                <el-radio :label="1">网课</el-radio>
                                <el-radio :label="2">上门</el-radio>
                                <el-radio :label="3">门店</el-radio>
                            </el-radio-group>
                        </div>
                    </div>


                    <!-- <div style=" display: flex;margin-bottom: 20px;">
                        <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;width: 120px;">是否首次课</div>
                        <div style="width: 100%;text-align: start;padding-top: 12px;">
                            <el-radio-group v-model="isFirstClass">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="2">否</el-radio>
                            </el-radio-group>
                        </div>
                    </div> -->


                    <div style=" display: flex;margin-bottom: 20px;">
                        <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;width: 120px;">循环排课</div>
                        <div style="width: 100%">
                            <el-select style="width: 100%"  v-model="relativeTime"  placeholder="请选择" filterable>
                                <el-option   style="margin-left: 10px"  v-for="item in relativeTimes"  :key="item.value"  :label="item.label"  :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </div>


                    <div style=" display: flex;margin-bottom: 20px;" v-if="relativeTime !== 4">
                        <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;width: 120px;">排课次数</div>
                        <div style="width: 100%;text-align: start;">
                            <el-input-number  v-model="num"  :min="1"  :max="99999"  label="描述文字"></el-input-number>
                        </div>
                    </div>

                    <div style=" display: flex;margin-bottom: 20px;" v-if="relativeTime === 3">
                        <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;width: 120px;">星期选择</div>
                        <div style="width: 100%;padding-top: 10px;">
                            <el-checkbox-group v-model="checkList" style="text-align: left">
                                <el-checkbox label="1">周一</el-checkbox>
                                <el-checkbox label="2">周二</el-checkbox>
                                <el-checkbox label="3">周三</el-checkbox>
                                <el-checkbox label="4">周四</el-checkbox>
                                <el-checkbox label="5">周五</el-checkbox>
                                <el-checkbox label="6">周六</el-checkbox>
                                <el-checkbox label="7">周日</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>


                    <div style="margin-bottom: 20px; text-align: start; padding-left: 20px;" v-if="studentIds">
                        <!-- <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">学业课总课时:{{ findStudentHour.schoolResidueHour }}</div>
                        <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">学业课消耗课时:{{ findStudentHour.schoolConsumeHour }}</div> -->
                        <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">学业课剩余课时:{{ findStudentHour.schoolResidueHour }}</div>
                        <!-- <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">家庭教育总课时:{{ findStudentHour.familySumHour }}</div>
                        <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">家庭教育消耗课时:{{ findStudentHour.familyConsumeHour }}</div> -->
                        <div style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">家庭教育剩余课时:{{ findStudentHour.familyResidueHour }}</div>
                    </div>


            </div>
            <div v-if="isShow" style="width: 25%; overflow-x: auto;">
               <div style="display: flex;" :style="{ width: FullCalendarList.length * 300 + 'px'}"   >
                    <FullCalendar  :ref=" index + 'fullCalendar'" :class="index + 'demo-app-calendar'"
                        :options="itme.calendarOptions"
                        style="width: 300px;margin-right: 10px;"
                        v-for="(itme,index) in FullCalendarList" :key="index">
                            <template v-slot:eventContent="arg">
                                <div>
                                  <div style="text-align: center;"> {{ arg.event.extendedProps.S }} ~ {{ arg.event.extendedProps.E }}  </div>
                                  <div style="text-align: center;" > {{ arg.event.title }} </div>
                                </div>
                            </template>
                                                             <!-- date, view -->
                            <template v-slot:dayHeaderContent="{  }" >
                                <span style="color: rgb(15 177 230);"> ({{ itme.realname }})  {{ itme.subjectName }} {{ itme.classType }}</span>
                                <el-checkbox @change="handleChangTemplate(index,itme)" v-model="itme.checkboxCalendarOptions"></el-checkbox>
                            </template>
                    </FullCalendar>
               </div>
            </div>
        </div>


        <div slot="footer" class="dialog-footer" style="text-align: end;">
           <el-button @click="handleCler" size="small">取 消</el-button>
           <el-button  type="primary"  size="small"  @click="submitForms">保存</el-button>
        </div>

    </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";

import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";

export default {
    components: {  FullCalendar, },
    props:['dateTime','ids'],
    data(){
        return{
            findStudentHour:{},
            ClassType:'',
            classPersonTypeList1:[],
            classPersonType:'',
            classPersonTypeList:[
                // {id:1,name:'孩子'},
                // {id:2,name:'孩子和父亲'},
                // {id:3,name:'孩子和母亲'},
                // {id:4,name:'父亲'},
                // {id:5,name:'母亲'},
                // {id:6,name:'父亲和母亲'},
                // {id:7,name:'孩子、父亲、母亲'},
            ],
            shouldRenderCalendar: true,
            checkboxCalendarOptions:true,
            FullCalendarList:[],
            isShow:false,
            studentIds:'',
            studentList:[],
            date:'',
            startTime:'',
            endTime:'',
            educationType: 2,
            isFirstClass:'',
            relativeTime: 4,
            checkList: [],
            num: 1,
            relativeTimes: [{ value: 1,  label: "每天",  },  { value: 2,   label: "每周",  },  { value: 3,   label: "自定义",  },  { value: 4,   label: "无",  }],
            realname:'',

            calendarOptionss:{
                handleWindowResize: true,
                firstDay: 1,
                allDaySlot: false,
                firstHour: 6,
                slotMinTime: "06:00:00",
                slotMaxTime: "24:00:00",
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin,
                ],
                locale: "zh-cn",
                initialView: "timeGridDay",
                editable: false,
                selectable: false,
                selectMirror: false,
                dayMaxEvents: false,
                weekends: true,
                eventDidMount: function (info) {
                    if (info.event.extendedProps.isConflict === 1) {
                         info.el.style.background = "red";
                         info.el.style.borderColor = "red";
                     }else{
                         info.el.style.background = "orange";
                         info.el.style.borderColor = "orange";
                     }
                },
                events: [],
                eventColor: function (event) {
                    if (event.start.isBefore(new Date())) {
                         return "f0f0f0";
                    } else {
                         return "#008000";
                    }
                },

            },

            teacherId:'',
            categoryId:'',
        }
    },

    mounted(){

        this.date = this.dateTime ? this.dateTime.slice(0, 10) : ''
        let data = { categoryId: '', ids: []}
        axios.post(`${apiBaseUrl}/student/getStudentByCategoryId`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => { this.studentList = res.data.data;})

        // if(this.ids && this.ids.length > 1){
        //     this.$message({  message: '只能选择一个学员~', type: "warning" });
        // }else{
        //     this.studentIds = this.ids
        // }
    },


    methods:{

        handleQueryScheduleList(){
            loadingUtils.startLoading();
             axios.post(`${apiBaseUrl}/preScheduled/queryScheduleList`, { studentId: this.studentIds,  startDate: this.date, startTime: this.startTime,  endTime: this.endTime, },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then((response) => {
                if(response.data.code === 200){
                    this.getListAssembly(response)
                    this.$message({  message: response.data.msg, type: "success" });
                }else{
                    this.$message({  message: response.data.msg, type: "error" });
                    loadingUtils.endLoading();
                }
             }).catch((err)=>{
                this.$message({  message: err, type: "error" });
                loadingUtils.endLoading();
             })
        },

        handleSelectProductSchedule(){
             loadingUtils.startLoading();
             axios.post(`${apiBaseUrl}/preScheduled/selectProductSchedule`, { studentId: this.studentIds,  startDate: this.date, startTime: this.startTime,  endTime: this.endTime, },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then((response) => {
                if(response.data.code === 200){
                    let data = response.data.data
                    this.FullCalendarList = []
                    this.getListAssemblys(data)
                }else{
                    loadingUtils.endLoading();
                }
             }).catch(()=>{
                this.$message({  message: err, type: "error" });
                loadingUtils.endLoading();
             })
        },


        handleChangeDate(e){
            if(this.studentIds){
                this.handleQueryScheduleList()
                this.handleSelectProductSchedule()

                this.date = e
            }else{
                this.date = this.dateTime
                this.$message({  message: '请选择学员~', type: "warning" });
            }

        },

        handleChangTemplate(e,itme){

            this.ClassType = itme.classType === '1v1' ? 1 : itme.classType === '1v2' ? 2 : itme.classType === '1v3' ? 3 : null
            this.teacherId = itme.realnameID
            this.categoryId = itme.subjectNameID


            this.FullCalendarList.forEach((itme,index)=>{
                if(e === index){

                }else{
                    itme.checkboxCalendarOptions = false
                }
            })

            let str = [this.studentIds]
            axios.post(`${apiBaseUrl}/preScheduled/getClassType`, { categoryId: itme.subjectNameID, studentId: '[' +  str  + ']'},{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then((res) => {
                let data = res.data.data
                if(data.length > 0){
                    data.forEach((itme)=>{
                        itme.id = itme.classType
                        itme.name = itme.classType === 1 ? '1v1' : itme.classType === 2 ? '1v2' : '1v3'
                    })
                    this.classPersonTypeList1 = data
                }else{
                    this.classPersonTypeList1 =[]
                    this.ClassType = ''
                    this.classPersonType = ''
                }
            })

        },

        handleChange(e){
            let name = this.studentList.filter((itme)=>{ return itme.id === e })
            this.realname = name[0].realname
            this.handleQueryScheduleList()
            this.handleSelectProductSchedule()
            this.isShow = true

            axios.post(`${apiBaseUrl}/student/findStudentHour`, { isHourMerge:2, id: this.studentIds },{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
                let data = res.data.data
                if(data){
                    this.findStudentHour = data
                }
            })

            // this.listdate({ time: this.date })
        },


        addTwoHours(currentHours, currentMinutes) {
            var now = new Date();
            now.setHours(currentHours, currentMinutes, 0, 0);
            now.setHours(now.getHours() + 2);
            return now.getHours() + ':' + now.getMinutes().toString().padStart(2, '0');
        },

        startTimeSelect(val, row) {
            if (val == "start") {
                this.startTime = row;
                let s = this.startTime.substring(0, 2)
                let d = this.startTime.substring(3, 5)
                this.endTime = this.addTwoHours(s, d)
            } else {
                this.endTime = row;
            }

            this.handleQueryScheduleList()
            this.handleSelectProductSchedule()
        },


        listdate(data = { }) {
            loadingUtils.startLoading();
             axios.post(`${apiBaseUrl}/preScheduled/selectschedule`, {
                teacher_id: '',
                page: "",
                limit: "",
                start_time: data.time,
                end_time: data.time,
                student_id: '',
                },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then((response) => {
                   this.getListAssembly(response)
                   loadingUtils.endLoading();
             })
        },

        handleChanges(e){
            if(this.ClassType){
                if(this.ClassType === 1){
                    this.classPersonTypeList = [{id:1,name:'孩子'},{id:4,name:'父亲'}, {id:5,name:'母亲'}, ]
                }
                if(this.ClassType === 2){
                    this.classPersonTypeList = [{id:2,name:'孩子和父亲'}, {id:3,name:'孩子和母亲'}, {id:6,name:'父亲和母亲'},]
                }
                if(this.ClassType === 3){
                    this.classPersonTypeList = [ {id:7,name:'孩子、父亲、母亲'} ]
                }
            }else{

            }
        },

        getListAssemblys(list){
            list.map((itme,index)=>{
                let data = { checkboxCalendarOptions: itme.checkboxCalendarOptions, index, classType: itme.onlineCategory.classType, subjectName: itme.onlineCategory.categoryName, subjectNameID: itme.onlineCategory.id, realname: itme.teacher.realname, realnameID: itme.teacher.id, scheduleList:[] }
                let b = [];
                for (let i = 0; i < itme.scheduleList.length; i++) {
                    var aa = {
                        classEnding: itme.scheduleList[i].classEnding,
                        title: itme.scheduleList[i].courseName,
                        scheduleId: itme.scheduleList[i].scheduleId,
                        isFirst: itme.scheduleList[i].isFirst ? itme.scheduleList[i].isFirst : 2,
                        start:itme.scheduleList[i].courseDate + " " + itme.scheduleList[i].courseTimeOn,
                        end: itme.scheduleList[i].courseDate + " " + itme.scheduleList[i].courseEndTime,
                        courseStatus: itme.scheduleList[i].courseStatus,
                        S:itme.scheduleList[i].courseTimeOn,
                        E:itme.scheduleList[i].courseEndTime,
                        isConflict:itme.scheduleList[i].isConflict,
                    };
                    var currentTime = new Date();
                    var specifiedTime = new Date(aa.start);
                    if (currentTime > specifiedTime) {
                        aa.color = "blue";
                        aa.isShowbgcColor = true;
                    } else {
                        aa.color = "";
                    }
                    b.push(aa);
                }

                data.scheduleList = b.length > 0 ? b : [{}]

                console.log(itme, 'init')

                if(index === 0){

                    let str = [this.studentIds]
                    axios.post(`${apiBaseUrl}/preScheduled/getClassType`, { categoryId: itme.onlineCategory.id, studentId: '[' +  str  + ']'},{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then((res) => {
                        let data = res.data.data
                        if(data.length > 0){
                            data.forEach((itme)=>{
                                itme.id = itme.classType
                                itme.name = itme.classType === 1 ? '1v1' : itme.classType === 2 ? '1v2' : '1v3'
                            })
                            this.classPersonTypeList1 = data
                        }else{
                            this.classPersonTypeList1 =[]
                            this.ClassType = ''
                            this.classPersonType = ''
                        }
                    })

                    this.ClassType = itme.onlineCategory.classType
                    this.teacherId = itme.teacher.id
                    this.categoryId = itme.onlineCategory.id
                }


                this.handleInitList(data,index)

            })

        },

        getListAssembly(response) {
            let b = [];
            for (let i = 0; i < response.data.data.length; i++) {
                var aa = {
                    classEnding: response.data.data[i].classEnding,
                    title: response.data.data[i].courseName,
                    scheduleId: response.data.data[i].scheduleId,
                    isFirst: response.data.data[i].isFirst ? response.data.data[i].isFirst : 2,
                    start:response.data.data[i].courseDate + " " + response.data.data[i].courseTimeOn,
                    end: response.data.data[i].courseDate + " " + response.data.data[i].courseEndTime,
                    courseStatus: response.data.data[i].courseStatus,
                    S:response.data.data[i].courseTimeOn,
                    E:response.data.data[i].courseEndTime,
                    isConflict:response.data.data[i].isConflict,
                };
                var currentTime = new Date();
                var specifiedTime = new Date(aa.start);
                if (currentTime > specifiedTime) {
                    aa.color = "blue";
                    aa.isShowbgcColor = true;
                } else {
                    aa.color = "";
                }
                 b.push(aa);
            }


            this.handleNoeCalendarOptionss(b)

            loadingUtils.endLoading();
        },


        handleInitList(init,index){
                let obj =  {
                    calendarOptions: {
                        handleWindowResize: true,
                        firstDay: 1,
                        allDaySlot: false,
                        firstHour: 6,
                        slotMinTime: "06:00:00",
                        slotMaxTime: "24:00:00",
                        plugins: [
                            dayGridPlugin,
                            timeGridPlugin,
                            interactionPlugin,
                        ],
                        locale: "zh-cn",
                        initialView: "timeGridDay",
                        editable: false,
                        selectable: false,
                        selectMirror: false,
                        dayMaxEvents: false,
                        weekends: true,
                        eventDidMount: function (info) {
                            if (info.event.extendedProps.isConflict === 1) {
                                info.el.style.background = "red";
                                info.el.style.borderColor = "red";
                            }else{
                                info.el.style.background = "orange";
                                info.el.style.borderColor = "orange";
                            }
                        },
                        events: init.scheduleList,
                        eventColor: function (event) {
                            if (event.start.isBefore(new Date())) {
                                return "f0f0f0";
                            } else {
                                return "#008000";
                            }
                        },

                    },
                    realname: init.realname,
                    classType: init.classType === 1 ? '1v1' : init.classType === 2 ? '1v2' : init.classType === 3 ? '1v3' : '',
                    realnameID: init.realnameID,
                    subjectName: init.subjectName,
                    subjectNameID: init.subjectNameID,
                    checkboxCalendarOptions: init.checkboxCalendarOptions ? init.checkboxCalendarOptions : false
                }


                setTimeout(()=>{
                    loadingUtils.startLoading();
                    this.FullCalendarList = [...this.FullCalendarList,...[obj]]
                    setTimeout(()=>{
                        this.$nextTick(()=>{
                            this.FullCalendarList.map((itme,index)=>{
                                let calendarApis = this.$refs[ index + "fullCalendar"][0].getApi()
                                calendarApis.gotoDate(this.date)
                                loadingUtils.endLoading();
                            })
                        })
                        loadingUtils.endLoading();
                    },500)
                },500)

      },

      dayHeaderContent(date, view) {
            return (' <div> <span>A老师 高中物理</span> <el-radio v-model="radio" :label="1">备选项</el-radio> </div>' )
      },


      handleNoeCalendarOptionss(init){
          this.calendarOptionss.events = init
          this.$nextTick(()=>{
            let calendarApi = this.$refs["fullCalendar"].getApi()
            calendarApi.gotoDate(this.date)
          })
      },

      submitForms(){
            let data = {
                num: this.num ? this.num : 1,
                checkList: this.checkList,
                relativeTime: this.relativeTime,
                educationType: this.educationType,
                // isFirst: this.isFirstClass,
                courseSchedulingNo: 1,
                courseId: this.categoryId,
                classId: 1,
                teacherId: this.teacherId,
                categoryId: this.categoryId,
                courseDate: this.date,
                courseTimeOn: this.startTime,
                courseEndTime: this.endTime,
                classroom: "一教室",
                numberOfClassDeductions: 0,
                recurrentScheduling: 0,
                canMakeAnAppointment: 0,
                courseNotes: "备注：赶紧上课思密达",
                studentId: this.studentIds,
                classPersonType: this.classPersonType,
                productClassType: this.ClassType

            };
            axios.post(`${apiBaseUrl}/preScheduled/addStuSch`, data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res) => {
                if (res.data.code == 200) {
                  this.$message({  message: res.data.msg, type: "success" })
                  this.$emit('handleEvent', false);
                } else {
                  this.$message({  message: res.data.msg, type: "error" })
                }
            })
      },

      handleCler(){
           this.$emit('handleEvent', false);
      },

    }
}

</script>

<style lang="less" scoped>

/deep/ .clock-picker__input{
    padding-left: 12px;
    width: 97.5%;
}
/deep/ .anniu[data-v-7fd4e108]{
    right: 10px;
}

/deep/ .fc-header-toolbar {
    display: none;
}

/deep/ .fc-view-harness {
    height: 600px !important;
}

// /deep/ .fc-scrollgrid-section-header {
//     display: none;
// }
.no-click {
  pointer-events: none;
}


/deep/ .fc-event-main{
    display: flex;
    align-items: center;
    justify-content: center;
}


</style>



// WEBPACK FOOTER //
// src/PreSchedule/workOutTeachingSchedule-components.vue